import { combineReducers } from 'redux'
import { IWarrantyClaimState, ResetProductWarrantyClaimAction, UpdateProductWarrantyClaimAction } from './actions'
import { RESET_PRODUCT_WARRANTY_CLAIM, UPDATE_PRODUCT_WARRANTY_CLAIM } from './types'

const defaultState: IWarrantyClaimState = {
  caseNumber: ''
}

type State = Readonly<IWarrantyClaimState>

type Actions = UpdateProductWarrantyClaimAction | ResetProductWarrantyClaimAction

const warrantyClaimReducer = (state: State = defaultState, action: Actions): State => {
  switch (action.type) {
    case UPDATE_PRODUCT_WARRANTY_CLAIM:
      return {
        ...state,
        ...action.payload
      }
    case RESET_PRODUCT_WARRANTY_CLAIM:
      return { ...defaultState }
    default:
      return state
  }
}

interface IProductWarrantyClaimState {
  detail: IWarrantyClaimState
}

const productWarrantyClaimReducer = combineReducers<IProductWarrantyClaimState>({
  detail: warrantyClaimReducer
})

export default productWarrantyClaimReducer
